import React from 'react';
import styled from 'styled-components';
import StripeProductList from '../components/StripeProductList';
import { Layout } from '../components/page-layout';

const StripeProductsPage: React.FC = () => {
  return (
    <Layout showCommonFooter>
      <PageHeroHeader>
        <PageHeroTitle>Stripe Products</PageHeroTitle>
        <PageHeroSubtitle>
          Browse our products managed through Stripe
        </PageHeroSubtitle>
      </PageHeroHeader>
      <Wrapper className='page'>
        <StripeProductList />
      </Wrapper>
    </Layout>
  );
};

const PageHeroHeader = styled.header`
  background: #fff;
  padding: 3rem 0 2rem 0;
  text-align: left;
  width: 100%;
  margin-bottom: 0;
`;

const PageHeroTitle = styled.h1`
  color: #F87B15;
  font-size: 2.5rem;
  font-weight: 800;
  margin: 0 0 0.5rem 3rem;
`;

const PageHeroSubtitle = styled.p`
  color: #666;
  font-size: 1.1rem;
  margin: 0 0 0 3rem;
`;

const Wrapper = styled.div`
  .page {
    min-height: calc(100vh - 10rem);
  }
`;

export default StripeProductsPage; 